import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const availabilityOptions = [
	{
		label: 'Immediate',
		value: 'Immediate',
	},
	{
		label: 'Within 1 month',
		value: 'Within_1_month',
	},
	{
		label: 'Within 3 months',
		value: 'Within_3_months',
	},
];

const AvailabilityFilterInput = ({ showSelect = false }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const availability = JSON.parse(searchParams.get('availability') || '[]');

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!availability?.length}
					placeholder={'Availability'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{availabilityOptions?.map(option => (
								<Button
									key={option?.value}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: availability?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (availability?.includes(option?.value?.toString())) {
											searchParams.set(
												'availability',
												JSON.stringify(availability?.filter((skill: string) => skill !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('availability', JSON.stringify([...availability, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									{option?.label}
									{availability?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Availability</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Immediate"
						options={availabilityOptions}
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						value={availabilityOptions?.filter(option => availability?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('availability', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default AvailabilityFilterInput;
